import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=03db18be&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=03db18be&prod&lang=css"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=03db18be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db18be",
  null
  
)

export default component.exports